(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_swv6-harness-price"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.SafeWalkV6HarnessPriceLoaded) return;
    window.SafeWalkV6HarnessPriceLoaded = true;

    const selector = '[data-swv6-harness-price]';

    const formatMoney = (cents, currency) => {
      const amount = Number(cents || 0);
      const hasMinorUnits = Math.abs(amount) % 100 !== 0;
      try {
        return new Intl.NumberFormat('he-IL', {
          style: 'currency',
          currency: currency || 'ILS',
          minimumFractionDigits: hasMinorUnits ? 2 : 0,
          maximumFractionDigits: 2
        }).format(amount / 100).replace(/\s/g, ' ');
      } catch (error) {
        return `₪${(amount / 100).toFixed(hasMinorUnits ? 2 : 0)}`;
      }
    };

    const update = (block, variant) => {
      if (!block || !variant) return;
      const purchase = block.closest('.swv5-main') || document;
      const currency = purchase.dataset.currency || 'ILS';
      const price = Number(variant.price || 0);
      const compare = Number(variant.compare_at_price || 0) || price;
      const percent = compare > price ? Math.floor(((compare - price) * 100) / compare) : 0;
      const currentNode = block.querySelector('[data-harness-current]');
      const compareNode = block.querySelector('[data-harness-compare]');
      const badgeNode = block.querySelector('[data-harness-sale-badge]');
      const badgeTextNode = block.querySelector('[data-harness-badge-text]');

      if (currentNode) {
        const prefix = purchase.dataset.sizeExplicitChoice === 'true' ? '' : block.dataset.fromPricePrefix || '';
        currentNode.textContent = `${prefix}${formatMoney(price, currency)}`;
      }
      if (compareNode) {
        compareNode.textContent = formatMoney(compare, currency);
        compareNode.hidden = block.dataset.showComparePrice !== 'true' || compare <= price;
      }
      if (badgeNode) badgeNode.hidden = block.dataset.showSaleBadge !== 'true' || percent <= 0;
      if (badgeTextNode) {
        badgeTextNode.textContent = (block.dataset.saleBadgeTemplate || '[percent]%').replace(/\[percent\]/g, String(percent));
      }
    };

    const currentVariant = (block) => {
      const purchase = block.closest('.swv5-main');
      const variantsNode = purchase?.querySelector('[data-swv5-variants]');
      const idNode = purchase?.querySelector('[data-variant-id]');
      if (!variantsNode || !idNode) return null;
      try {
        const variants = JSON.parse(variantsNode.textContent || '[]');
        return variants.find((variant) => Number(variant.id) === Number(idNode.value)) || null;
      } catch (error) {
        return null;
      }
    };

    const initialize = (scope = document) => {
      const blocks = [];
      if (scope.matches?.(selector)) blocks.push(scope);
      scope.querySelectorAll?.(selector).forEach((block) => blocks.push(block));
      blocks.forEach((block) => update(block, currentVariant(block)));
    };

    document.addEventListener('swv5:variant-change', (event) => {
      const purchase = event.target?.closest?.('.swv5-main') || event.target;
      purchase?.querySelectorAll?.(selector).forEach((block) => update(block, event.detail?.variant));
    });
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:block:select', (event) => initialize(event.target));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
